import _ from 'lodash';

export default function findDefaultStationCode(nodes) {
    const lastNode = _.findLast(nodes, (x) => x.isLastBagNode);

    return lastNode?.stationCode ?? nodes[0].stationCode;
}
